import React from 'react';
import styled, { ThemeProvider, withTheme } from 'styled-components';

const Floater = styled.div`
  @media (min-width: 576px) {
    float: left;
    margin: 5px;
  }
`;

const Title = styled.p`
  font-size: 12px;
  color: #333;
  text-align: center;
  line-height: 18px;
  margin: 0;
`;

const DeviceWin = styled.div`
  background-color: ${props => props.theme.bg};
  width: 375px;
  height: 667px;
  position: relative;
  display: flex;
  overflow: hidden;
`;

const Flexer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  height: 100%;
  justify-content: ${props => (props.centered ? 'center' : 'flex-start')};
  align-items: ${props => (props.centered ? 'center' : 'flex-start')};
  z-index: 1;
`;

const CustomBg = styled.img`
  position: absolute;
  left: -50%;
  width: 200%;
  height: 100%;
  opacity: 0.5;
`;

const Screen = ({
  children, theme, title, centered, customBg,
}) => {
  const customTitle = title ? <Title>{title}</Title> : null;
  const customBackground = customBg ? <CustomBg src={customBg} /> : null;
  return (
    <ThemeProvider theme={theme}>
      <div>
        <Floater>
          <DeviceWin>
            {customBackground}
            <Flexer centered={centered}>{children}</Flexer>
          </DeviceWin>
          {customTitle}
        </Floater>
      </div>
    </ThemeProvider>
  );
};

export default withTheme(Screen);



// WEBPACK FOOTER //
// ./src/components/Screen.js